<template>
  <div class="content-wrapper">
    <el-row>
      <el-col :span="24" class="y-title">
        <span class="title-content">{{ yTitle }}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col v-for="item in contentItems" :key="item.id" :xs="24" :sm="12" :lg="6">
        <div class="item-image">
          <img :src="item.image">
        </div>
        <div class="item-content">
          <span>{{ item.text }}</span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    props: [
      "yTitle",
      "contentItems"
    ],
    data() {
      return {

      };
    },
    methods: {

    }
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  @import "../../commons/style/index.scss";

  .item-image {
    text-align: center;
  }
  .item-content {
    text-align: center;
    height: 60px;
    padding-top: 10px;
    color: $color-text-default;
    font-size: $font-size-h3;
  }
</style>



// WEBPACK FOOTER //
// src/components/y-head-content/y-head-content.vue